import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AveriasService } from '../servicios/averias.service';
import { buquesDTO } from "../entidades/entidades.component";
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { Injectable } from '@angular/core';

import { SelectModule } from 'primeng/select';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver'; 


@Component({
    selector: 'app-buques',
    templateUrl: './buques.component.html',
    styleUrls: ['./buques.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, 
      MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, 
      MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, 
      MultiSelectModule,
      AgGridAngular,
      NbSelectModule,
      SelectModule,
NbCheckboxModule,
    ],
    providers: [DatePipe],
  })
export class BuquesComponent implements OnInit {

  durationInSeconds = 3;
  eliminar = false;
  buques: SelectItem[];
  buquesOK = false;
  idBuques: number;
  showBuques = false
  BuquesProcesado;
  BuquesProcesadoModificar;
  operadorProcesado;
  operadorProcesadoModificar;
  firstForm: UntypedFormGroup;
  descripcionBuques;
  descripcionBuquesEditar;
  descripcionBreve;
  descripcionBreveEditar;
  codigoExterno;
  codigoExternoEditar;
  buquesCompleto;
  name = new UntypedFormControl('');
  idCliente: number;
  datasetBuques: any[] = [];
  datasetBuquesConsulta: any[] = [];
  datasetBuquesModificar: any[] = [];
  angularGridBuques: AngularGridInstance;
  angularGridBuquesConsulta: AngularGridInstance;
  angularGridBuquesModificar: AngularGridInstance;

  showSpinner = false;
  columnDefinitionsBuques: ColDef[];//Column[];
  columnDefinitionsModificar: ColDef[];//Column[];
  gridOptionsBuques: GridOption;
  
  
  columnDefinitionsBuquesConsulta: ColDef[];//Column[];
  columnDefinitionsBuquesModificar: ColDef[];//Column[];
  gridOptionsBuquesConsulta: GridOption;
  gridOptionsBuquesModificar: GridOption;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  showSpinnerConsulta = false;
  showBuquesConsulta = false;
  showBuquesModificar = false;
  eliminarSeleccionado;
  operadorNaviera: SelectItem [];
  operadorNavieraOK = false;
  idOperadorNaviera: number;
  operadorNavieraCompleto;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private fb: FormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit() {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });   
    this.svcAnalytics.setAnalyticsPageView();  
  };
  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarBuques();
      this.consultarOperadorNaviera();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarBuquesConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarBuquesModificar();
      this.consultarOperadorNaviera();
    }
  };
  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  };
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  };
  consultarBuques() {
    this.showSpinner = true;
    this.showBuques = false;
    this.AveriasService.getBuques().subscribe(
      data => {
        this.buquesCompleto = data;
        this.buques = this.insertarBuques(data);
        this.traerDatosBuques();
        this.fillGrillaBuques();
    });
  };
  consultarBuquesConsulta() {
    this.showSpinnerConsulta = true;
    this.showBuquesConsulta = false;
    this.AveriasService.getBuques().subscribe(
      data => {
        this.buquesCompleto = data;
        this.traerDatosBuquesConsulta();
        this.fillGrillaBuquesConsulta();
      });
  };
  consultarBuquesModificar() {
    this.showBuquesModificar = false;
    this.showSpinnerModificar = true;
    this.AveriasService.getBuques().subscribe(
      data => {
        this.buquesCompleto = data;
        this.buques = this.insertarBuques(data);
        this.traerDatosBuquesModificar();
        this.fillGrillaBuquesModificar();
      });
  };
  insertarBuques(armarBuque) {
    let averiasBuques: Array<any> = [];
    armarBuque.content.forEach(element => {
      averiasBuques.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasBuques;
  };
  capturarBuques(event) {
    this.idBuques = event;
    this.buquesOK = true;
  };
  consultarOperadorNaviera() {
    this.showSpinner = true;
    this.showBuques = false;
    this.AveriasService.getOperadoresNavieraPorCliente(this.idCliente).subscribe(
      data => {
        this.operadorNavieraCompleto = data;
        this.operadorNaviera = this.insertarOperadorNaviera(data);
    });
  };
  insertarOperadorNaviera(armarOperadorNaviera) {
    let operadorNaviera: Array<any> = [];
    armarOperadorNaviera.forEach(element => {
      operadorNaviera.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return operadorNaviera;
  };
  capturarOperadorNaviera(event) {
    this.idOperadorNaviera = event;
    this.operadorNavieraOK = true;
  };
  altaBuques() {
    let buques: buquesDTO;

    if (this.descripcionBuques == null || this.descripcionBuques == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if(this.operadorProcesado == null || this.operadorProcesado == ""){
      this.openSnackBar("Debe completar el Operador ❌");
    } else {
      buques = {
        descripcion: this.descripcionBuques,
        idOperador: this.operadorProcesado
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postBuques(buques).subscribe(data => {
        if (data["status"] == 200) {
          this.openSnackBar('Los cambios se han guardado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.descripcionBuques = '';
        this.consultarBuques();
        this.showSpinnerGuardar = false;
      })
    }
  };
  modificarBuques() {
    let buques: buquesDTO;
    if (this.eliminar) {
      this.AveriasService.deleteBuques(this.BuquesProcesadoModificar).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionBuquesEditar = '';
          this.BuquesProcesado = '';
          
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.consultarBuquesModificar();
        this.eliminar = false;
        this.eliminarSeleccionado = false;
      })
    } else {

      if (this.descripcionBuquesEditar == null || this.descripcionBuquesEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if(this.BuquesProcesadoModificar == null || this.BuquesProcesadoModificar == ""){
        this.openSnackBar("Debe seleccionar un Buque ❌");
      } else if(this.operadorProcesadoModificar == null || this.operadorProcesadoModificar == ""){
        this.openSnackBar("Debe seleccionar un Operador ❌");
      } else {
        this.showSpinnerModificar = true;
        buques = {
          descripcion: this.descripcionBuquesEditar,
          idOperador: this.operadorProcesadoModificar,
        }
        this.AveriasService.putBuques(this.BuquesProcesadoModificar, buques).subscribe(data => {
          if (data["status"] == 200) {
            this.openSnackBar('Los cambios se han guardado correctamente');            
          } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
          this.showSpinnerModificar = false;
          this.eliminar = false;
          this.eliminarSeleccionado = false;
          this.consultarBuquesModificar();
        })
        this.descripcionBuquesEditar = '';
        this.BuquesProcesadoModificar = '';
        this.operadorProcesadoModificar = '';
        this.eliminarSeleccionado = false;
        this.eliminar = false;
      }
    }
  };
  obtenerDescripcionDropdown(idBuques: number) {
    let resp = this.buquesCompleto.content.find(n => n['id'] == idBuques);
    this.descripcionBuquesEditar = resp['descripcion'];
    this.operadorProcesadoModificar = resp['idOperador'];
    this.eliminarSeleccionado = false;
  };  
  traerDatosBuques() {
    let DatosBuque = this.buquesCompleto['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosBuque.length; i++) {
      mockDataset.push({
        id: DatosBuque[i]["id"],
        Descripcion: DatosBuque[i]["descripcion"],
      });
    }
    this.datasetBuques = mockDataset;
    this.showSpinner = false;
    this.showBuques = true;
  };
  traerDatosBuquesConsulta() {
    let DatosBuque = this.buquesCompleto['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosBuque.length; i++) {
      mockDataset.push({
        id: DatosBuque[i]["id"],
        Descripcion: DatosBuque[i]["descripcion"],
      });
    }
    this.datasetBuquesConsulta = mockDataset;
    this.showSpinnerConsulta = false;
    this.showBuquesConsulta = true;
  };
  traerDatosBuquesModificar() {
    let DatosBuque = this.buquesCompleto['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosBuque.length; i++) {
      mockDataset.push({
        id: DatosBuque[i]["id"],
        Descripcion: DatosBuque[i]["descripcion"],
      });
    }
    this.datasetBuquesModificar = mockDataset;
    this.showBuquesModificar = true;
    this.showSpinnerModificar = false;
  };
  fillGrillaBuques() {
    this.columnDefinitionsBuques = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsBuques = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  };
  fillGrillaBuquesConsulta() {
    this.columnDefinitionsBuquesConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsBuquesConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  };
  fillGrillaBuquesModificar() {
    this.columnDefinitionsBuquesModificar = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', 
        field: 'Descripcion', 
        sortable: true, 
        filter: true, floatingFilter: true,  
        minWidth: 548,
        width: 548, },
    ];
    this.gridOptionsBuquesModificar = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  };
  angularGridReadyBuques(angularGrid: AngularGridInstance) {
    this.angularGridBuques = angularGrid;
    this.angularGridBuques.resizerService.pauseResizer(false)
  };
  angularGridReadyBuquesConsulta(angularGrid: AngularGridInstance) {
    this.angularGridBuquesConsulta = angularGrid;
    this.angularGridBuquesConsulta.resizerService.pauseResizer(false)
  };
  angularGridReadyBuquesModificar(angularGrid: AngularGridInstance) {
    this.angularGridBuquesModificar = angularGrid;
    this.angularGridBuquesModificar.resizerService.pauseResizer(false)
  };
  // exportToExcelBuques() {
  //   (this.angularGridBuquesConsulta as any).excelExportService.exportToExcel({
  //     filename: 'Buques_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
  //     format: FileType.xlsx
  //   });
  // };


  exportToExcelBuques(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Buques': worksheet },
          SheetNames: ['Buques']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Buques_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
}
